<template>
    <div class="row">
        <div class="col-md-12">
            <div class="">
                <div class="d-flex">
                    <div style="width: 30%" class="mr-2 font-weight-bold">Field</div>
                    <div style="width: 30%" class="mr-2 font-weight-bold">Value</div>
                    <div style="width: 20%" class="mr-2 font-weight-bold">Operator</div>
                    <div style="width: 10%" class="font-weight-bold">Actions</div>
                </div>
                <div v-for="(singleCondition, key) in conditionBlock.conditions">
                    <condition-single :key="key" :condition-id="key" :block-id="blockId" :condition-prop="singleCondition"></condition-single>
                </div>
                <div class="row mt-1">
                    <div class="col-md-12">
                        <div class="d-flex">
                            <button class="btn btn-sm btn-primary mr-2" @click="addCondition('AND')">
                                AND
                            </button>
                            <button class="btn btn-sm btn-primary" @click="addCondition('OR')">
                                OR
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import ConditionSingle from "./ConditionSingle.vue";

export default {
    name: "ConditionBlock",
    components: {ConditionSingle},
    props: {
        blockId: {type: String, required: false},
        conditionBlock: {type: Object, required: false},
    },
    data() {
        return {}
    },

    methods: {
        addCondition(operator) {
            this.$parent.addCondition(this.blockId, operator);
        }
    }

}
</script>

<style scoped>

</style>
